
const quizSelectors = {
    nextStepBtns: document.querySelectorAll('#recommendation-quiz [data-next]'),
    backStepBtns: document.querySelectorAll('#recommendation-quiz [data-back]'),
    steps: document.querySelectorAll('#recommendation-quiz [data-step-container]'),
    showResultsFirstStep: document.querySelectorAll('#recommendation-quiz [data-showResults-step-1]'),
    showResultsSecondStep: document.querySelectorAll('#recommendation-quiz [data-showResults-step-2]'),
    showResultsThirdStep: document.querySelectorAll('#recommendation-quiz [data-showResults-step-3]'),
    resultConstructionEquipmentContainer: document.querySelector('#recommendation-quiz .quiz-result-step'),
    resultContainer: document.querySelector('#recommendation-quiz .quiz-result-step'),
    retakeQuiz: document.querySelectorAll('#recommendation-quiz [data-retake-quiz]'),
    selectedVehicleBtn: document.querySelectorAll('#recommendation-quiz .quiz-result-step [data-selected-btn]'),
    searchVehicleBtn: document.querySelector('#quiz-add-vehicle [data-quiz-shop-vehicle-btn-new]'),
    searchHeavyEquipmenteBtn: document.querySelector('#quiz-add-vehicle [data-shop-heavy-btn]')
};
class templateQuizJS {
    constructor() {
        quizSelectors.nextStepBtns.forEach((nextBtn)=>{
            nextBtn.addEventListener('click', (event)=>{
                this._gotToNext(event);
            });
        });
        quizSelectors.backStepBtns.forEach((backBtn)=>{
            backBtn.addEventListener('click', (event)=>{
                this._goBack(event);
            });
        });
        quizSelectors.showResultsFirstStep.forEach((firstStep)=>{
            firstStep.addEventListener('click', (event)=>{
                firstStep.querySelector("input").checked = !firstStep.querySelector("input").checked;
                firstStep.classList.add("active");
                const siblings = Array.from(firstStep.parentElement.children);
                siblings.forEach((sibling) => {
                if (sibling !== firstStep) {
                      sibling.classList.remove("active");
                   }
                });
                this.showResultsFirstStep(event);
            });
        });
        quizSelectors.showResultsSecondStep.forEach((secondStep) => {
            secondStep.querySelectorAll(".quiz-step-item").forEach((stepOption, index) => {
                    stepOption.addEventListener('click', (event) => {
                        stepOption.querySelector("input").checked = !stepOption.querySelector("input").checked;
                        stepOption.classList.add("active");
                        const siblings = Array.from(stepOption.parentElement.children);
                        siblings.forEach((sibling) => {
                        if (sibling !== stepOption) {
                              sibling.classList.remove("active");
                           }
                        });
                        const materials = stepOption.dataset.materials;
                        const jsonObject = JSON.parse(materials);
                        if (index === 1) {
                        this.showResultsSecondstep(event);
                        }
                        else if(index === 0){
                            document.querySelector(".collection_material").style.order = "1";
                            this.showResultsThirdStep(event, jsonObject);
                        }
                    });
            });
        });

        quizSelectors.showResultsThirdStep.forEach((ThirdStep) => {
            ThirdStep.querySelectorAll(".quiz-step-item").forEach((stepOption, index) => {
                    stepOption.addEventListener('click', (event) => {
                        if(index === 0 ){
                            document.querySelector(".collection_material").style.order = "1";
                        }
                        else{
                            document.querySelector(".collection_material").style.order = "unset";
                        }
                        stepOption.querySelector("input").checked = !stepOption.querySelector("input").checked;
                        stepOption.classList.add("active");
                        const siblings = Array.from(stepOption.parentElement.children);
                        siblings.forEach((sibling) => {
                        if (sibling !== stepOption) {
                              sibling.classList.remove("active");
                           }
                        });
                        const materials = stepOption.dataset.materials;
                        const jsonObject = JSON.parse(materials);
                        this.showResultsThirdStep(event, jsonObject);
                    });
            });
        });
        
        quizSelectors.retakeQuiz.forEach((retake)=>{
            retake.addEventListener('click', (event)=>{
                this._retakeQuiz(event);
            });
        });
       

        quizSelectors.selectedVehicleBtn.forEach(selectedVehicleBtn => {
            selectedVehicleBtn.addEventListener('click',(event)=>{
                this.searchVehicleBtn(event);
            });
        }); 

      
        quizSelectors.searchHeavyEquipmenteBtn.addEventListener('click', (event)=>{
            this._searchHeavyEquipment(event);
        });
        
    }
   
    _gotToNext(event){
        event.preventDefault();
        let currentTarget = event.currentTarget;
        let stepContainer = currentTarget.closest('[data-step-container]');
        let stepCount = parseInt(stepContainer.getAttribute('data-stepIndex'));
        let nextStepContainer = document.querySelector(`[data-step-container][data-stepIndex="${stepCount + 1}"]`);
        stepContainer.classList.add('d-none');
        nextStepContainer.classList.remove('d-none');
        document.querySelectorAll('[data-step-container] .quiz-step-item').forEach((stepsOptions)=>{
            stepsOptions.classList.remove('active');
            stepsOptions.querySelector("input").checked = false;
        });
    }
    _goBack(event){
        event.preventDefault();
        let currentTarget = event.currentTarget;
        let stepContainer = currentTarget.closest('[data-step-container]');
        let stepCount = parseInt(stepContainer.getAttribute('data-stepIndex'));
        if(stepCount <= 1) return;
        if(stepCount === 2 ){
            let prevStepContainer = document.querySelector(`[data-step-container][data-stepIndex="${stepCount - 1}"]`);
            prevStepContainer.classList.remove('d-none');
            stepContainer.classList.add('d-none');
        }
        else{
        let prevStepContainer = document.querySelectorAll(`[data-step-container][data-stepIndex="${stepCount - 1}"]`);
        prevStepContainer.forEach((preStep)=>{
            preStep.querySelectorAll(".quiz-step-item").forEach((findActive)=>{
               if(findActive.classList.contains('active'))
               {
                findActive.classList.remove("active");
                findActive.closest("[data-step-container]").classList.remove('d-none');
                stepContainer.classList.add('d-none');
               }
            });
        });
      }
    }
    showResultsFirstStep(event){
        event.preventDefault();
        let currentTarget = event.currentTarget;
        let stepValue = currentTarget.querySelector('input').value;
        console.log(stepValue);
        if(stepValue === 'tractor-ag-equipment'){
            window.location.href = '/collections/tractor-lawn-mower-seat-covers'
        } else if(stepValue === 'side-by-side'){
            window.location.href = '/collections/side-by-side-seat-covers'
        } else {
            let nextStepContainer = document.querySelectorAll(`[data-step-container][data-stepIndex="3"]`);
            nextStepContainer.forEach((nextStepName) => {
              const stepName = nextStepName.dataset.stepName;

              console.log(nextStepName);
              console.log(stepName);
              console.log(stepValue);
              if( stepName == stepValue)
              {
                nextStepName.classList.remove('d-none');
                document.querySelector(`[data-step-container][data-stepIndex="2"]`).classList.add('d-none');
                 if(nextStepName.classList.contains('construction_result')){
                    document.querySelector('.index-reviews-block').style.display = "block";
                    document.querySelector('.features-content').style.display = "block";
                    document.querySelector('.construction_result').style.display = "block";
                 }
              }
              else{
                nextStepName.classList.add('d-none');
              }
            });
        }
      
    }
    showResultsSecondstep(event){
        event.preventDefault();
        let currentTarget = event.currentTarget;
        let stepValue = currentTarget.closest('[data-step-name]').dataset.stepName;
        let nextStepContainer = document.querySelectorAll(`[data-step-container][data-stepIndex="4"]`);
        nextStepContainer.forEach((nextStepName, index) => {
          const stepName = nextStepName.dataset.stepName;
          if( stepName == stepValue)
          {
            nextStepName.classList.remove('d-none');
            quizSelectors.showResultsSecondStep.forEach((secondStep) => {
                secondStep.classList.add("d-none");
            });
          }
          else{
            nextStepName.classList.add('d-none');
          }
        });
    }

    showResultsThirdStep(event , jsonObject){
        event.preventDefault();
        let nextStepContainer = document.querySelector('.quiz-result-step');
        nextStepContainer.classList.remove('d-none');
        document.querySelector('.index-reviews-block').style.display = "block";
        document.querySelector('.features-content').style.display = "block";
        let firstMatchFound = false;
        nextStepContainer.querySelectorAll("[data-material]").forEach((material)=>{
            const materialTitle = material.dataset.material;
            if (jsonObject.includes(materialTitle)) {
                const computedStyle = getComputedStyle(material);
                const orderValue = computedStyle.getPropertyValue('order');
                if (!firstMatchFound && orderValue === '0') {
                    material.classList.add('recommendation-product');
                    firstMatchFound = true;
                } else {
                    material.classList.remove('recommendation-product');
                }
                material.classList.remove('d-none');
            } else {
                material.classList.add('d-none');
            }
        });
        
        quizSelectors.showResultsSecondStep.forEach((secondStep) => {
            secondStep.classList.add("d-none");
        });
        quizSelectors.showResultsThirdStep.forEach((thirdStep) => {
            thirdStep.classList.add("d-none");
        });
          
    }

    _retakeQuiz(event){
        event.preventDefault();
        quizSelectors.resultContainer.classList.add('d-none');
        quizSelectors.resultConstructionEquipmentContainer.classList.add('d-none');
        quizSelectors.steps[0].classList.remove('d-none');
        document.querySelector('.index-reviews-block').style.display = "none";
        document.querySelector('.features-content').style.display = "none";
        document.querySelector('.construction_result').style.display = "none";
        quizSelectors.steps.forEach((step, index)=>{
            let optionInputs = step.querySelectorAll('input.quiz-option-selection');
            if(optionInputs.length > 0){
                optionInputs.forEach(input => {
                    input.checked = false;
                });
                step.querySelector('input.quiz-option-selection').checked = true;
            }
        });
    }
    searchVehicleBtn(event){
        let selectedMaterial = event.target.closest('.collection_material').dataset.materialhandle;
        window.globalVariables.selected_material = selectedMaterial;
        let makeSelect = document.querySelector("[data-make-filter-select]");
        makeSelect.addEventListener('change', function (event) {
         if (event.target.matches('input')) {
         document.querySelectorAll('[data-modal-filter-select] input').forEach((modalInput)=>{
            modalInput.addEventListener("change", function(){
                document.querySelector('[data-quiz-shop-vehicle-btn-new]')?.classList.remove('disabled');
            })
          });
         }
      });
        let modalVehicle = document.querySelector('#quiz-add-vehicle #vehicle_modal');
        modalVehicle.addEventListener('click', (event) => {
         const target = event.target;
         if (target.matches('[data-quiz-shop-vehicle-btn-new]')) {
             this._searchVehicle(event);
          }
        });
      let manufacturerSelect = document.querySelector("[data-heavy-manufacturer-select-filter]");
      manufacturerSelect.addEventListener('change', function (event) {
         if (event.target.matches('input')) {
         document.querySelectorAll('[data-heavy-model-select-filter] input').forEach((modalInput)=>{
            modalInput.addEventListener("change", function(){
                document.querySelector('[data-quiz-shop-heavy-btn]')?.classList.remove('disabled');
            })
          });
         }
      });
        let modalHeavyEquipment = document.querySelector('#quiz-add-vehicle #heavy_equipment_modal');
         modalHeavyEquipment.addEventListener('click', (event) => {
          const target = event.target;
          if (target.matches('[data-quiz-shop-heavy-btn]')) {
              this._searchHeavyEquipment(event);
           }
         });
     }
     
     _searchVehicle(event){
        let selectedYear = document.querySelector('[data-year-filter-select] [name="year-filter"]:checked').value;
        let selectedMake = document.querySelector('[data-make-filter-select] [name="ymm-filter-make"]:checked').value;
        let selectedModel = document.querySelector('[data-modal-filter-select] [name="ymm-filter-models"]:checked').value;
        let selectedTrimEle = document.querySelector('[data-trim-filter-select] [name="ymm-filter-trim"]:checked');
        let selectedTrim = selectedTrimEle ? selectedTrimEle.value : "" ;
        let selectedCabEle = document.querySelector('[data-cab-filter-select] [name="ymm-filter-cab"]:checked');
        let selectedCab = selectedCabEle ? selectedCabEle.value : "" ;
        let selectedMaterial = window.globalVariables.selected_material;
        let partsEls = document.querySelectorAll('[data-part-wrap] [data-part-filter-select] li');


        // let selectedEqipType = document.querySelector('[data-heavy-category-select-filter] [name="heavy-filter-type"]:checked').value;
        // let selectedEqipManufacturer = document.querySelector('[data-heavy-manufacturer-select-filter] [name="heavy-filter-manufacturer"]:checked').value;
        // let selectedEqipModel = document.querySelector('[data-heavy-model-select-filter] [name="heavy-filter-model-number"]:checked').value;
       
        let selectedData;
        if(selectedYear != ''){
            selectedData = {
                "year":selectedYear,
                "make":selectedMake,
                "model":selectedModel,
                "trim":selectedTrim,
                "cabType":selectedCab
            }
        }
       

        localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedData))


        let uniquePartNumbers = [];
        partsEls.forEach((partsEl) => {
            let part = partsEl.getAttribute('data-value');
            uniquePartNumbers.push(part);
        });

        var prefixedParts = uniquePartNumbers.map(function(element) {
            return "sku-" + element;
        });
        var partsNumber = prefixedParts.join(",");
        
        if(partsNumber != ''){
            window.location.href=`/collections/all?filter.p.tag=${partsNumber}`;
        }
        
      
        // if(selectedTrim != ''){
        //     window.location.href=`/collections/all?filter.p.m.custom.product_year=${selectedYear}&filter.p.m.custom.product_make=${selectedMake}&filter.p.m.custom.product_model=${selectedModel}&filter.p.m.custom.product_trim=${selectedTrim}&filter.p.m.custom.product_cab_type=${selectedCab}`
        // } else {
        //     window.location.href=`/collections/all?filter.p.m.custom.product_year=${selectedYear}&filter.p.m.custom.product_make=${selectedMake}&filter.p.m.custom.product_model=${selectedModel}`
        // }
        
       
    }

     _searchHeavyEquipment(event){
        let selectedEqipType = document.querySelector('[data-heavy-category-select-filter] [name="heavy-filter-type"]:checked').value;
        let selectedEqipManufacturer = document.querySelector('[data-heavy-manufacturer-select-filter] [name="heavy-filter-manufacturer"]:checked').value;
        let selectedEqipModel = document.querySelector('[data-heavy-model-select-filter] [name="heavy-filter-model-number"]:checked').value;
        let selectedMaterial = window.globalVariables.selected_material;
        let partsEls = document.querySelectorAll('[data-equipment-part-wrap] [data-equipment-part-filter-select] li');

        let selectedData;
        if(selectedEqipType != ''){
            selectedData = {
                "equipment_category":selectedEqipType,
                "equipment_manufacturer":selectedEqipManufacturer,
                "equipment_model_number":selectedEqipModel
            }
        }

        localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedData))

        let uniquePartNumbers = [];
        partsEls.forEach((partsEl) => {
            let part = partsEl.getAttribute('data-value');
            uniquePartNumbers.push(part);
        });

        var prefixedParts = uniquePartNumbers.map(function(element) {
            return "sku-" + element;
        });
        var partsNumber = prefixedParts.join(",");
        
        if(partsNumber != ''){
            window.location.href=`/collections/all?filter.p.tag=${partsNumber}`;
        }

    }
}
typeof templateQuizJS !== 'undefined' && new templateQuizJS();